import { createDateRangeFromType, DateRange } from 'owa-datetime-utils';
import { endOfDay } from 'owa-datetime';
import { DatesColumnProvider } from 'owa-calendar-surface-dategrid';
import type { ViewSetting, WorkWeekViewSettings } from '..';

/**
 * Gets the range of visible dates based on the given view settings.
 * This function takes work days into account on a WorkWeek view.
 */
export function getVisibleDateRange(viewSettings: ViewSetting & WorkWeekViewSettings): DateRange {
    // Get the date range which is being printed
    const { view, date, firstDayOfWeek, workWeekDays } = viewSettings;
    const dateRange = createDateRangeFromType(
        view,
        date,
        firstDayOfWeek,
        workWeekDays,
        1 // TODO VSO 80768: Create flexible day view prop in CalendarPrintDialog so calendar print can use flexible day settings
    );

    // Get the actual first and last dates that are being displayed
    const columnProvider = new DatesColumnProvider({
        dayStartMinute: 0,
        dayLength: 0,
        dateRange,
        dateRangeType: view,
        userOptions: {
            workDays: workWeekDays,
        },
    });

    const dates = columnProvider.columnModels;
    const start = dates[0];
    const end = endOfDay(dates[dates.length - 1]);

    return { start, end };
}
